import { FreightAllowanceAutoCalc, Shipment } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'shipment';

export class ShipmentFreightAllowanceController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getSuggestedFreightAllowance(
    shipment: Shipment,
  ): Promise<FreightAllowanceAutoCalc> {
    const response = await this.http.post<FreightAllowanceAutoCalc>(
      `freight-allowance/suggested`,
      { shipment },
    );
    return new FreightAllowanceAutoCalc(response.data);
  }
}
